import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-suceess",
  "use": "icon-ic-suceess-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"icon-ic-suceess\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.824 12c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Zm-4.794-1.545a.998.998 0 0 0-1.411-1.41l-5.295 5.294-2.294-2.294a.997.997 0 1 0-1.411 1.41l3 3a.998.998 0 0 0 1.41 0l6-6Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol